import { RECAPTCHA_SITE_ID } from '../constants/environment';

interface GrecaptchaEnterprise {
  ready: (cb: () => void) => void;
  execute: (siteKey: string, options: { action: string }) => Promise<string>;
}

declare global {
  interface Window {
    grecaptcha: {
      enterprise: GrecaptchaEnterprise;
    };
  }
}

let scriptLoaded = false;

const loadScript = (): Promise<void> => {
  if (scriptLoaded && window.grecaptcha?.enterprise) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const existing = document.querySelector('script[src*="recaptcha/enterprise.js"]');
    if (existing) {
      scriptLoaded = true;
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${RECAPTCHA_SITE_ID}`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      scriptLoaded = true;
      resolve();
    };
    script.onerror = () => reject(new Error('Failed to load reCAPTCHA Enterprise script'));
    document.head.appendChild(script);
  });
};

export const executeRecaptcha = async (action: string): Promise<string> => {
  //console.log('executeRecaptcha called, RECAPTCHA_SITE_ID:', RECAPTCHA_SITE_ID);

  try {
    await loadScript();
    //console.log('Script loaded, enterprise object:', !!window.grecaptcha?.enterprise);

    const enterprise = window.grecaptcha?.enterprise;

    if (!enterprise) {
      throw new Error('reCAPTCHA Enterprise not loaded');
    }

    return new Promise((resolve, reject) => {
      enterprise.ready(() => {
        //console.log('Enterprise ready, executing...');
        enterprise
          .execute(RECAPTCHA_SITE_ID, { action })
          .then(token => {
            //console.log('Token received:', token?.substring(0, 20) + '...');
            resolve(token);
          })
          .catch(err => {
            //console.error('Enterprise execute failed:', err);
            reject(err);
          });
      });
    });
  } catch (err) {
    //console.error('executeRecaptcha failed:', err);
    throw err;
  }
};
